// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalModalBackdrop_backdrop__YhaAr {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(1, 1, 1, 0.37);
}
.GlobalModalBackdrop_backdropNonInteractive__arywX {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/global-modals/components/GlobalModalBackdrop/GlobalModalBackdrop.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;AACF;AACE;EACE,oBAAA;AACJ","sourcesContent":[".backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(1, 1, 1, 0.37);\n\n  &NonInteractive {\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `GlobalModalBackdrop_backdrop__YhaAr`,
	"backdropNonInteractive": `GlobalModalBackdrop_backdropNonInteractive__arywX`
};
export default ___CSS_LOADER_EXPORT___;
